import { isLeftSidebarMenuKey, writeLeftSidebarMenuState } from '../js/left-sidebar-menu-cookie.js';

/**
 *
 * @param app
 */
export function initialize(app) {
  if (app.ports.setItem) {
    app.ports.setItem.subscribe(function ([key, value]) {
      if (isLeftSidebarMenuKey(key)) {
        writeLeftSidebarMenuState(value);
        return;
      }
      if (value === '') {
        localStorage.removeItem(key);
      } else {
        localStorage.setItem(key, value);
      }
    });
  }

  if (app.ports.clearAllItems) {
    app.ports.clearAllItems.subscribe(function (accountUuid) {
      const itemsForAccount = filterObjectByKeyPrefix(localStorage, accountUuid);
      itemsForAccount.forEach(([key]) => {
        localStorage.removeItem(key);
      });
    });
  }
}

/**
 * @param {object} obj
 * @param {string} prefix
 * @returns {object} A new object with only the keys that start with the prefix
 */
export const filterObjectByKeyPrefix = (obj, prefix) => {
  const filteredEntries = Object.entries(obj).filter(([key]) => key.startsWith(prefix));
  return filteredEntries;
};
